// src/pages/About.js (The rewritten component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // <--- Import Helmet
// import useMeta from '../../hooks/useMeta'; // <--- NO LONGER NEEDED

import Navbar from '../../CommonComponent/Navbar/Navbar';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';
import Footer from '../../CommonComponent/Footer/footer';
import ABComponent from './PageComponent/ABComponent';

function About() {
  // Use the Helmet component to declare all your SEO tags
  return (
    <>
      <Helmet>
        {/* Primary SEO Tags */}
        <title>About Us | Marvel Callistus</title>
        <meta
          name="description"
          content="At Marvel Lifestyle, Visit our about us page to uncover our values and the vision that drives us to inspire change in every life we touch."
        />
        <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/about/`} />

        {/* Open Graph Tags (for Social Media Sharing) */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="About Us" />
        <meta
          property="og:description"
          content="At Marvel Lifestyle, Visit our about us page to uncover our values and the vision that drives us to inspire change in every life we touch."
        />
        <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/about/`} />
        <meta property="og:site_name" content="Marvel Blinds" />
        
        {/* You can add Twitter Card tags here as well */}
        {/* <meta name="twitter:card" content="summary_large_image" /> */}

      </Helmet>

      {/* Rest of your component JSX */}
      <div>
        <Navbar />
        <NotificationBar />
        <ABComponent />
        <Footer />
      </div>
    </>
  );
}

export default About;